import { CrudState } from "@/store/Crud/State";

export class State extends CrudState {
  categoryListIsLoading = false;
  categoryListError: string | null = null;
  categoryList: Array<any> = [];
  studentCategoriesSubcategories: Array<any> = [];
  studentSubcategoryDetailed: Record<string, any> = {};
}
